module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Tally Reverse Invoice")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total Reverse Amount: " + _vm._s(_vm.formatCurrency(_vm.totalReverseAmount)) + " | Total Records: " + _vm._s(_vm.totalRecords))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by document no, client name...",
      "size": "sm"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n            Refresh\n          ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "items": _vm.tallyReverseInvoiceData,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "striped": "",
      "bordered": "",
      "hover": "",
      "small": "",
      "show-empty": "",
      "empty-text": "No reverse invoice data found"
    },
    scopedSlots: _vm._u([{
      key: "documentNo",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "documentDate",
      fn: function(data) {
        return [_vm._v("\n          " + _vm._s(_vm.formatDate(data.value)) + "\n        ")]
      }
    }, {
      key: "documentType",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "buyerLegalName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.buyerTradeName))])]
      }
    }, {
      key: "jobDetails.JobNo",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "jobDetails.POL",
      fn: function(data) {
        return [_c('small', [_vm._v(_vm._s(data.value) + " → " + _vm._s(data.item.jobDetails.POD))])]
      }
    }, {
      key: "amount",
      fn: function(data) {
        return [_c('strong', {
          staticClass: "text-right d-block"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "items",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(data.value.length || 0))])]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('b-button', {
          staticClass: "toggle-btn",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.toggleDetails(data.item)
            }
          }
        }, [_c('i', {
          class: data.item._showDetails ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
        })])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-details"
        }, [_c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-primary"
        }, [_c('div', {
          staticClass: "card-header bg-primary text-white"
        }, [_c('i', {
          staticClass: "fa fa-info-circle"
        }), _vm._v(" Job Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.jobDetails.JobDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row.item.jobDetails.RaisedBy) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Shipping Line:")]), _vm._v(" " + _vm._s(row.item.jobDetails.SlineName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Vessel:")]), _vm._v(" " + _vm._s(row.item.jobDetails.VesselName) + " (" + _vm._s(row.item.jobDetails.VoyageNo) + ")\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("SOB:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.jobDetails.SOB)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Master BL:")]), _vm._v(" " + _vm._s(row.item.jobDetails.MasterBL || 'N/A') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("House BL:")]), _vm._v(" " + _vm._s(row.item.jobDetails.HouseBL || 'N/A') + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row.item.jobDetails.RaisedFrom) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-success"
        }, [_c('div', {
          staticClass: "card-header bg-success text-white"
        }, [_c('i', {
          staticClass: "fa fa-map-marker"
        }), _vm._v(" Location Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row.item.jobDetails.POR) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row.item.jobDetails.POL) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row.item.jobDetails.POD) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row.item.jobDetails.FPOD) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Stuffing:")]), _vm._v(" " + _vm._s(row.item.jobDetails.STUFF) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-2"
        }, [_c('strong', [_vm._v("Handover:")]), _vm._v(" " + _vm._s(row.item.jobDetails.HAND) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-warning"
        }, [_c('div', {
          staticClass: "card-header bg-warning"
        }, [_c('i', {
          staticClass: "fa fa-users"
        }), _vm._v(" Client & Enquiry Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Main Client:")]), _vm._v(" " + _vm._s(row.item.jobDetails.ClientName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Exporter:")]), _vm._v(" " + _vm._s(row.item.jobDetails.ExpClientName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Importer:")]), _vm._v(" " + _vm._s(row.item.jobDetails.ImpClientName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry:")]), _vm._v(" " + _vm._s(row.item.jobDetails.EnqNo) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.jobDetails.EnqDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Billing Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.BillingType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("BL Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.BLType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('strong', [_vm._v("Login User:")]), _vm._v(" " + _vm._s(row.item.jobDetails.LoginUserName) + " (" + _vm._s(row.item.jobDetails.LoginUserEmail) + ")\n                      ")])])])])])]), _vm._v(" "), (row.item.items && row.item.items.length > 0) ? _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-danger"
        }, [_c('div', {
          staticClass: "card-header bg-danger text-white"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v(" Invoice Items (" + _vm._s(row.item.items.length) + ")\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body p-0"
        }, [_c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.items,
            "fields": _vm.itemFields,
            "small": "",
            "bordered": ""
          },
          scopedSlots: _vm._u([{
            key: "unitPrice",
            fn: function(data) {
              return [_vm._v("\n                        " + _vm._s(_vm.formatCurrency(data.value)) + "\n                      ")]
            }
          }, {
            key: "totalAmount",
            fn: function(data) {
              return [_vm._v("\n                        " + _vm._s(_vm.formatCurrency(data.value)) + "\n                      ")]
            }
          }])
        })], 1)])])]) : _vm._e(), _vm._v(" "), (row.item.modules && row.item.modules.length > 0) ? _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-info"
        }, [_c('div', {
          staticClass: "card-header bg-info text-white"
        }, [_c('i', {
          staticClass: "fa fa-cubes"
        }), _vm._v(" Modules (" + _vm._s(row.item.modules.length) + ")\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body p-0"
        }, [_c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.modules,
            "fields": _vm.moduleFields,
            "small": "",
            "bordered": ""
          },
          scopedSlots: _vm._u([{
            key: "unitPrice",
            fn: function(data) {
              return [_vm._v("\n                        " + _vm._s(_vm.formatCurrency(data.value)) + "\n                      ")]
            }
          }, {
            key: "totalAmount",
            fn: function(data) {
              return [_vm._v("\n                        " + _vm._s(_vm.formatCurrency(data.value)) + "\n                      ")]
            }
          }])
        })], 1)])])]) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle",
    attrs: {
      "small": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v("Loading...")])], 1)])], 2), _vm._v(" "), (_vm.totalItems > _vm.pagination.perPage) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalItems
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pagination.pageOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.pagination.perPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "perPage", $$v)
      },
      expression: "pagination.perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("per page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Total Records: " + _vm._s(_vm.totalItems) + " | Total Amount: " + _vm._s(_vm.formatCurrency(_vm.totalReverseAmount)) + "\n        ")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ef9265","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/TallyReverseInvoiceSection.vue
// module id = 2376
// module chunks = 0